import { render, staticRenderFns } from "./ActivityWsImage.vue?vue&type=template&id=754b5722&scoped=true"
import script from "./ActivityWsImage.vue?vue&type=script&lang=ts"
export * from "./ActivityWsImage.vue?vue&type=script&lang=ts"
import style0 from "./ActivityWsImage.vue?vue&type=style&index=0&id=754b5722&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754b5722",
  null
  
)

export default component.exports